<template>
  <v-card class="mx-auto contact-card">
    <div class="desktop-container" v-html="cms_page.html"></div>
  </v-card>
</template>

<script>
import hubbdata from "@/hubbdata";

export default {
  computed: {
    cms_page() {
      return hubbdata.getters.getCmsPageByPath('about')
    },
  },
  mounted: function() {
    ga('set', 'title', "About"); // eslint-disable-line
    ga('send', 'pageview', location.href); // eslint-disable-line
  }
}
</script>

<style lang="scss" scoped>
  .contact-card {
    height: 100%;
    border-radius: 0px;
    margin: 0px;
    padding: 30px;
  }
</style>